/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetSuggestionsQueryStringRequest,
  TGetSuggestionsQueryStringModel,
  IMappers,
  TGetSuggestionsQueryStringResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetSuggestionsResponseV2 } from '../../entities/suggestions_query_string/GetSuggestionsResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetSuggestionsQueryStringModel(
  parameters: TGetSuggestionsQueryStringRequest,
): TGetSuggestionsQueryStringModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'text-search',
    pathApi: '/v2/get-suggestions-query-string/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetSuggestionsQueryStringOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetSuggestionsQueryStringRequest;
}

export async function fetchGetSuggestionsQueryString<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSuggestionsQueryStringOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetSuggestionsQueryStringResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetSuggestionsQueryStringModel(parameters),
    config,
  )) as FetchResponse<TGetSuggestionsQueryStringResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSuggestionsResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetSuggestionsQueryStringResponse>;
}
